module.exports = __webpack_public_path__ + "img/depmap_svg_V128.1b64fc37.svg";